import { debugLog } from '@/utils/logger'
import DashboardService from '@/services/DashboardService'

export default {
  state: {
    counters: {},
    charts: {},
    cumulatedTurnoverChart: {}
  },
  mutations: {
    SET_COUNTERS(state, counters) {
      state.counters = counters
    },
    SET_CHARTS(state, charts) {
      state.charts = charts
    },
    SET_CUMULATED_TURNOVER_CHART(state, cumulatedTurnoverChart) {
      state.cumulatedTurnoverChart = cumulatedTurnoverChart
    }
  },
  actions: {
    /**
     * Fetch in state a counters
     *
     * @param commit
     * @param data
     */
    fetchCounters({ commit }, data)
    {
      // AD-104 : renvoyer la requête, sinon l'écran enchaîne avant l'arrivée des données (chargement infini des graphiques)
      return DashboardService.getCounters(data)
        .then(response => {
          commit('SET_COUNTERS', response.data)

          return Promise.resolve(response.data)
        })
        .catch(error => debugLog(error, 'DashboardModule'))
    },
    /**
     * Fetch data for charts
     *
     * @param commit
     * @param data
     */
    fetchCharts({ commit }, data)
    {
      // AD-104 : renvoyer la requête, sinon l'écran enchaîne avant l'arrivée des données (chargement infini des graphiques)
      return DashboardService.getCharts(data)
        .then(response => {
          commit('SET_CHARTS', response.data)
        })
        .catch(error => debugLog(error, 'DashboardModule'))
    },
    fetchCumulatedTurnoverChart({ commit }, data)
    {
      // AD-104 : renvoyer la requête, sinon l'écran enchaîne avant l'arrivée des données (chargement infini des graphiques)
      return DashboardService.getCumulatedTurnoverChart(data)
        .then(response => {
          commit('SET_CUMULATED_TURNOVER_CHART', response.data)
        })
        .catch(error => debugLog(error, 'DashboardModule'))
    },
  },
  getters: {

  }
}
